import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import NowSecureConfigListing from './NowSecureConfigListing';
import NowSecureCredentialsForm from './NowSecureCredentialsForm';

const NowSecurePullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={NowSecureCredentialsForm}
        PullConfigListingView={NowSecureConfigListing}
     />
);

export default NowSecurePullAndPushView;
